import { getIrrigationStatusDotColor } from 'App/Map/_utils/getIrrigationStatusDotColor'
import { getIrrigationStatusLabel } from 'App/Map/_utils/getIrrigationStatusLabel'
import { IRRIGATION_STATUS_DOT_SIZE } from 'App/Map/_utils/irrigationStatusDotSize'
import type { TIrrigationDeviceStatus } from 'App/Map/types'

export const IrrigationStatusDot = ({ status }: { status: TIrrigationDeviceStatus }) => {
  const label = getIrrigationStatusLabel(status)

  return (
    <span
      role="img"
      aria-label={label}
      title={label}
      css={{
        display: 'block',
        flex: 'none',
        width: IRRIGATION_STATUS_DOT_SIZE,
        height: IRRIGATION_STATUS_DOT_SIZE,
        borderRadius: '50%',
        background: getIrrigationStatusDotColor(status),
      }}
    />
  )
}
